import React from 'react';

import { GameType } from '../game/game';
import { GameUiModule } from '../game/game-module';
import { get } from '../util/fetch';
import { GameEvent } from './events/event';
import { updateKingOfTokyo } from './king-of-tokyo.reducer';
import { KingOfTokyoView } from './king-of-tokyo';

const KingOfTokyoRoot = React.lazy(() => import('./KingOfTokyo'));

/** How the client hosts King of Tokyo. */
export const kingOfTokyoUiModule: GameUiModule<KingOfTokyoView> = {
  gameType: GameType.KingOfTokyo,
  title: 'King of Tokyo',
  splash: `${process.env.PUBLIC_URL}/kot/splash.jpg`,
  loadView: (gameId: string) => get<KingOfTokyoView>(`/game/${gameId}/state`),
  reduce: (view, event) => updateKingOfTokyo(view, event as GameEvent),
  Root: KingOfTokyoRoot,
};
